/* SEW Markaz - product image viewer. See the note in assets/sew-lightbox.css.

   Opens from a tap on any photo in the main product gallery. Matching is by
   Shopify media id (the gallery's data-media-id is "<section>-<media id>"),
   so it lands on the right photo whatever order Dawn shows them in after a
   variant change. Videos and 3D models are not in the viewer and keep their
   own players. The listener runs in the capture phase so nothing else in
   the theme opens a second modal on the same tap. */

(function () {
  function init() {
    var lb = document.querySelector('[data-sew-lb]');
    if (!lb || lb.dataset.sewReady === 'true') return;
    lb.dataset.sewReady = 'true';

    var track = lb.querySelector('[data-sew-lb-track]');
    var slides = Array.prototype.slice.call(track.children);
    var count = lb.querySelector('[data-sew-lb-count]');
    var dots = Array.prototype.slice.call(lb.querySelectorAll('[data-sew-lb-dot]'));
    var prev = lb.querySelector('[data-sew-lb-prev]');
    var next = lb.querySelector('[data-sew-lb-next]');
    var closeBtn = lb.querySelector('[data-sew-lb-close]');
    var cur = 0;
    var lastFocus = null;
    var scrollTimer = null;

    function indexOfMedia(id) {
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].getAttribute('data-media-id') === String(id)) return i;
      }
      return -1;
    }

    function update(i) {
      cur = i;
      if (count) count.textContent = (i + 1) + ' / ' + slides.length;
      dots.forEach(function (d, k) {
        d.classList.toggle('is-active', k === i);
        d.setAttribute('aria-current', k === i ? 'true' : 'false');
      });
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === slides.length - 1;
    }

    function go(i, smooth) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      var left = i * track.clientWidth;
      if (typeof track.scrollTo === 'function') {
        track.scrollTo({ left: left, behavior: smooth ? 'smooth' : 'auto' });
      } else {
        track.scrollLeft = left;
      }
      update(i);
    }

    function open(i) {
      lastFocus = document.activeElement;
      lb.hidden = false;
      document.documentElement.classList.add('sew-lb-lock');
      window.requestAnimationFrame(function () {
        go(i, false);
        lb.classList.add('is-open');
        if (closeBtn) {
          try { closeBtn.focus({ preventScroll: true }); } catch (e) { closeBtn.focus(); }
        }
      });
    }

    function close() {
      lb.classList.remove('is-open');
      document.documentElement.classList.remove('sew-lb-lock');
      window.setTimeout(function () {
        if (!lb.classList.contains('is-open')) lb.hidden = true;
      }, 200);
      if (lastFocus && typeof lastFocus.focus === 'function') {
        try { lastFocus.focus({ preventScroll: true }); } catch (e) { /* ignore */ }
      }
    }

    track.addEventListener('scroll', function () {
      window.clearTimeout(scrollTimer);
      scrollTimer = window.setTimeout(function () {
        if (!track.clientWidth) return;
        var i = Math.round(track.scrollLeft / track.clientWidth);
        if (i !== cur) update(i);
      }, 60);
    }, { passive: true });

    if (prev) prev.addEventListener('click', function () { go(cur - 1, true); });
    if (next) next.addEventListener('click', function () { go(cur + 1, true); });
    dots.forEach(function (d, k) {
      d.addEventListener('click', function () { go(k, true); });
    });
    lb.addEventListener('click', function (e) {
      if (e.target.closest('[data-sew-lb-close]')) close();
    });

    document.addEventListener('keydown', function (e) {
      if (lb.hidden) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') go(cur - 1, true);
      else if (e.key === 'ArrowRight') go(cur + 1, true);
    });
    window.addEventListener('resize', function () {
      if (!lb.hidden) go(cur, false);
    });

    // A tap on a photo in the main gallery opens the viewer on that photo.
    document.addEventListener('click', function (e) {
      var item = e.target.closest('.product__media-list .product__media-item');
      if (!item) return;
      if (e.target.closest('deferred-media, .product__xr-button, video, iframe, model-viewer')) return;
      var raw = item.getAttribute('data-media-id') || '';
      var id = raw.split('-').pop();
      var i = indexOfMedia(id);
      if (i < 0) return;
      e.preventDefault();
      e.stopPropagation();
      open(i);
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
